import { useQuery } from '@tanstack/react-query';

import { useRequest, getForwardingEmailKey } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  ForwardingEmailData,
  UseForwardingEmailListCreateParams,
  ForwardingEmailKey,
} from './types';

export const useGetForwardingEmails: QueryFunction<
  ForwardingEmailData[],
  [UseForwardingEmailListCreateParams],
  ForwardingEmailKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getForwardingEmailKey();
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/email_forwarding_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
